import styled from 'styled-components';

import { AuthCard } from 'ggApp/shared/screens/Auth/Auth.styles';

export const NewCheckoutModalWrap = styled(AuthCard)`
    border: none;
    min-height: 670px;
`;
